import { render } from "./Usuarios.vue?vue&type=template&id=33811d32&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"comensales\":\"data\",\"initSectorSelects\":\"options\",\"sendInfo\":\"options\",\"sendNuevo\":\"options\",\"guardar\":\"options\",\"nuevo_guardar\":\"options\"}"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"

import "./Usuarios.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script